import { Badge } from "@/components/ui/Feedback";

const STATE_TONE: Record<string, "neutral" | "primary" | "accent" | "danger"> = {
  new: "primary",
  open: "primary",
  pending: "accent",
  closed: "neutral",
  merged: "neutral",
  removed: "neutral",
};

/** The state's own name (it is data), colored by its category. */
export function StateBadge({ name, category }: { name: string; category: string }) {
  return <Badge tone={STATE_TONE[category] ?? "neutral"}>{name}</Badge>;
}

function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/** `text` with every occurrence of the search terms wrapped in <mark> (case-insensitive). */
export function Highlight({ text, terms }: { text: string; terms: string[] }) {
  const words = terms.map((term) => term.replace(/\*+$/, "").trim()).filter((term) => term.length > 1);
  if (words.length === 0) return <>{text}</>;
  const pattern = new RegExp(`(${words.map(escapeRegExp).join("|")})`, "gi");
  return (
    <>
      {text.split(pattern).map((part, index) =>
        index % 2 === 1 ? (
          <mark key={index} className="rounded-sm bg-accent-soft px-0.5 text-ink">
            {part}
          </mark>
        ) : (
          part
        ),
      )}
    </>
  );
}
